import React from 'react';
import {
  Link,
  useNavigate,
} from '@tanstack/react-router';

import UserAvatar from './UserAvatar';

import { useStore } from '../store';

const Header: React.FC = () => {
  const profile = useStore((state) => state.profile);
  const nav = useNavigate();

  return (
    <header className="main-header wa-grid wa-gap-0 wa-align-items-center">
      <div className="logo">
        <Link to="/">
          <img src="/images/lgcy-logo.png" alt="LGCY" />
        </Link>
      </div>
      <nav className="nav-links wa-justify-content-end wa-align-items-center wa-cluster">
        {profile?.id ? (
          <>
            <wa-button appearance="accent" className="cta-button" onClick={() => nav({ to: '/memories/create' })} size="s">
              Create something
            </wa-button>
            <Link to="/dashboard">Dashboard</Link>
            <Link to="/logout">Logout</Link>
            <Link to="/account">
              <UserAvatar />
            </Link>
          </>
        ) : (
          <>
            <wa-button appearance="outlined" onClick={() => nav({ to: '/login', search: { redirect: window.location.href } })} size="s">
              Sign in
            </wa-button>
            <wa-button appearance="accent" onClick={() => nav({ to: '/memories/create' })} size="s">
              Start your own LGCY
            </wa-button>
          </>
        )}
      </nav>
    </header>
  );
}

export default Header;
